import React from 'react'
import { connect } from "react-redux";
import Pt from 'prop-types'
import { Button, Col, Panel, Row } from 'react-bootstrap'

import Icon from 'internal-components/src/components/Icon'
import { SignupWithExternalsRecord } from 'internal-components/src/records'

import DetailTable from './DetailTable'
import ProgressDiagram from './ProgressDiagram'
import Qualification from './Qualification'
import * as signupActions from "../../redux/modules/signupEdit/actions";

function SignupDetails({ continueSignup, signupWithExternals, setCoupon, applyCoupon }) {
  const signup = signupWithExternals.signup
  const showQualification =
    signupWithExternals.product.get('addressRequired') &&
    ['submitted'].indexOf(signup.state) > -1
  const isNbn = signupWithExternals.product.get('type') === 'NBN'

  const mailtoSubject = `Assistance with Signup ${signup.reference}`
  const mailtoLink = `mailto:support@infinite.net.au?subject=${encodeURIComponent(
    mailtoSubject,
  )}`

  let expectedCoupon = null;

  if (signupWithExternals.coupon === null &&
    !signupWithExternals.offer.attributes.includes('calix') &&
    (signupWithExternals.product.get('type') == 'VDSL')) {
    if (signupWithExternals.offer.attributes.includes('personal')) {
      expectedCoupon = {code: 'VISION20OFF', discount: 20, months: 6};
    } else {
      expectedCoupon = {code: 'MYVISION2024', discount: 20, months: 12};
    }
  }

  return (
    <div className="signup-details">
      <Row>
        <Col md={8}>
          {showQualification && (
            <Qualification signupWithExternals={signupWithExternals} />
          )}

          <DetailTable signupWithExternals={signupWithExternals} expectedCoupon={expectedCoupon} />
        </Col>

        <Col md={4}>
          <Panel>
            <Panel.Body>
              <h4>If you need help</h4>

              <p>
                If you have any enquiries or need any assistance with your
                signup while it is being processed or after it is installed,
                please contact us by email via{' '}
                <a href={mailtoLink}>support@infinite.net.au</a> or call us on{' '}
                <tel>1300 790 337</tel> during business hours.
              </p>
            </Panel.Body>
          </Panel>
        </Col>
      </Row>

      {signup.get('state') === 'new' && (
        <Button
          bsSize="large"
          bsStyle="success"
          onClick={() => continueSignup(signup.get('id'))}
        >
          <Icon name="rocket" /> Continue Signup
        </Button>
      )}
      {signup.get('state') !== 'new' && signup.get('state') !== 'cancelled' && isNbn &&
        <ProgressDiagram signupWithExternals={signupWithExternals}/>
      }
    </div>
  )
}

SignupDetails.propTypes = {
  continueSignup: Pt.func.isRequired,
  signupWithExternals: Pt.instanceOf(SignupWithExternalsRecord).isRequired,
}

export default connect(null, signupActions)(SignupDetails);



// WEBPACK FOOTER //
// ./src/components/SignupDetails/index.jsx